/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { ApiError } from '../api/core/ApiError';
import { ApiRequestOptions } from '../api/core/ApiRequestOptions';
import { ApiResult } from '../api/core/ApiResult';

import { DealerControllerService } from './services/DealerControllerService';
import { GroupControllerService } from './services/GroupControllerService';
import { LeasysControllerService } from './services/LeasysControllerService';
import { UserControllerService } from './services/UserControllerService';
import { VehicleActionsControllerService } from './services/VehicleActionsControllerService';
import { VehicleControllerService } from './services/VehicleControllerService';
import { AreaAcademyControllerService } from './services/AreaAcademyControllerService';
import { AreaMarketingControllerService } from './services/AreaMarketingControllerService';
import { SalesforceAccountControllerService } from './services/SalesforceAccountControllerService';
import { SalesforceOpportunityControllerService } from './services/SalesforceOpportunityControllerService';
import { TiassistoControllerService } from './services/TiassistoControllerService';
import { AutorevolWizardControllerService } from './services/AutorevolWizardControllerService';
import { LeadsControllerService } from './services/LeadsControllerService';
import { StellantisControllerService } from './services/StellantisControllerService';
import { CarConfiguratorControllerService } from './services/CarConfiguratorControllerService';
import { MotornetControllerService } from './services/MotornetControllerService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class Api {
    public readonly dealerController: DealerControllerService;
    public readonly groupController: GroupControllerService;
    public readonly leasysController: LeasysControllerService;
    public readonly userController: UserControllerService;
    public readonly vehicleActionsController: VehicleActionsControllerService;
    public readonly vehicleController: VehicleControllerService;
    public readonly areaAcademyController: AreaAcademyControllerService;
    public readonly areaMarketingController: AreaMarketingControllerService;
    public readonly salesforceAccountController: SalesforceAccountControllerService;
    public readonly salesforceOpportunityController: SalesforceOpportunityControllerService;
    public readonly tiassistoController: TiassistoControllerService;
    public readonly autorevolWizardController: AutorevolWizardControllerService;
    public readonly leadsControllerService: LeadsControllerService;
    public readonly stellantisControllerService: StellantisControllerService;
    public readonly carConfiguratorController: CarConfiguratorControllerService;
    public readonly motornetControllerService: MotornetControllerService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1.0-SNAPSHOT',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.dealerController = new DealerControllerService(this.request);
        this.groupController = new GroupControllerService(this.request);
        this.leasysController = new LeasysControllerService(this.request);
        this.userController = new UserControllerService(this.request);
        this.vehicleActionsController = new VehicleActionsControllerService(this.request);
        this.vehicleController = new VehicleControllerService(this.request);
        this.areaAcademyController = new AreaAcademyControllerService(this.request);
        this.areaMarketingController = new AreaMarketingControllerService(this.request);
        this.salesforceAccountController = new SalesforceAccountControllerService(this.request);
        this.salesforceOpportunityController = new SalesforceOpportunityControllerService(this.request);
        this.tiassistoController = new TiassistoControllerService(this.request);
        this.autorevolWizardController = new AutorevolWizardControllerService(this.request);
        this.leadsControllerService = new LeadsControllerService(this.request);
        this.stellantisControllerService = new StellantisControllerService(this.request);
        this.carConfiguratorController = new CarConfiguratorControllerService(this.request);
        this.motornetControllerService = new MotornetControllerService(this.request);
    }

    /**
     * Make a request to the API and handle any errors that occur. NEEDED because there was no way to receive backend messages
     */
    async makeRequest(endpoint: string, options: RequestInit): Promise<any> {
        const response = await fetch(endpoint, options);

        // Check if the response is not successful (status code 4xx or 5xx)
        if (!response.ok) {
            // Extract the error body from the response
            const errorBody = await response.json();

            // Cast the method to the allowed HTTP methods
            const method = (options.method || 'GET') as 'GET' | 'PUT' | 'POST' | 'DELETE' | 'OPTIONS' | 'HEAD' | 'PATCH';

            // Create an object conforming to ApiRequestOptions
            const apiRequestOptions: ApiRequestOptions = {
                url: endpoint,
                method,  // Now correctly typed to the accepted string literals
                headers: options.headers,
                body: options.body ? JSON.parse(options.body as string) : undefined,
            };

            // Create an ApiResult object with the required properties
            const apiResult: ApiResult = {
                url: endpoint,
                status: response.status,
                statusText: response.statusText,
                body: errorBody,
                ok: response.ok,  // Include the `ok` property
            };

            // Throw an ApiError with the error body
            throw new ApiError(apiRequestOptions, apiResult, 'API request failed');
        }

        // Return the JSON response for successful requests
        return response.json();
    }

}
